import React, { useState } from 'react';
import JsonNavigator from '../../jsonnavigator/JsonNavigator.js';
import sampleJson from '../sampleJson.js';
import { Box, Paper } from '@mui/material';
import { Link, Outlet } from 'react-router-dom';
import Button from '../../components/Button.js';

const Actors = () => {

    return <Box>
        <Paper sx={{mb : 3, p : 3, textAlign : 'center'}}>
            <h3>Tous vos acteurs</h3>
            <Box sx={{display : 'flex', flexDirection : 'row', justifyContent : 'space-evenly', p : 2}}>
                <Button sx={{width : 200}} to="/multisport/actors/players" component={Link}>ATHLETES</Button>
                <Button sx={{width : 200}} to="/multisport/actors/teams" component={Link}>EQUIPES</Button>
            </Box>
        </Paper>

        <Outlet />
    </Box>

}



export default Actors